import React from 'react';

export const ApifyLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <div className="w-8 h-8 flex items-center justify-center">
    <svg
      {...props}
      viewBox="0 0 408 408"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
    >
      <g clipPath="url(#apify_clip)">
        <path
          d="M218.695 104H300.97C302.643 104 304 105.357 304 107.03V232.766C304 235.778 300.083 236.945 298.434 234.425L216.159 108.69C214.841 106.674 216.287 104 218.695 104Z"
          fill="#246DFF"
        />
        <path
          d="M189.305 104H107.03C105.357 104 104 105.357 104 107.03V232.766C104 235.778 107.917 236.945 109.566 234.425L191.84 108.69C193.159 106.674 191.713 104 189.305 104Z"
          fill="#20A34E"
        />
        <path
          d="M202.591 204.668L109.127 298.835C107.229 300.747 108.583 304 111.278 304H296.8C299.483 304 300.842 300.77 298.967 298.852L206.908 204.685C205.726 203.475 203.782 203.468 202.591 204.668Z"
          fill="#F86606"
        />
      </g>
      <defs>
        <clipPath id="apify_clip">
          <rect
            width="200"
            height="200"
            fill="white"
            transform="translate(104 104)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
);
